import { getNextgenSettingsWorkflowUrl } from '@jira/project-settings__common/src/getClassicIssueLayoutSettingsUrl.tsx';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants';
import type { Column } from '../../../../../../../model/column/column-types.tsx';
import type { ColumnIssueTypeTransitions } from '../../../../../../../model/card-transition/card-transition-types.tsx';

/**
 * Get the workflow URL for setting up an agent rule.
 * This will only auto-open the "Trigger Agent" rule in the workflow editor for a transition ID,
 * hence the autoOpenSystemRule=trigger-agent query param.
 */
export const getWorkflowUrlForAgentRule = ({
	projectKey,
	issueTypeId,
	transitionId,
}: {
	projectKey: string;
	issueTypeId: string;
	transitionId: string;
}) =>
	`${getNextgenSettingsWorkflowUrl(SOFTWARE_PROJECT, projectKey, issueTypeId)}?selectedTransition=${transitionId}&autoOpenSystemRule=trigger-agent`;

/**
 * Get the first status ID from a column.
 */
export const getFirstStatusId = (column: Column): string | undefined => {
	if (column && 'statuses' in column && column.statuses.length > 0)
		return column.statuses[0]?.id?.toString();
	return undefined;
};

/**
 * Find the transition ID for a given column, issue type, and status.
 */
export const findTransition = ({
	transitions,
	columnId,
	issueTypeId,
	statusId,
}: {
	transitions: ColumnIssueTypeTransitions;
	columnId: string;
	issueTypeId: string;
	statusId: string;
}): string | undefined => {
	if (!transitions[columnId] || !transitions[columnId][issueTypeId]) {
		return undefined;
	}
	const issueTypeTransitions = transitions[columnId][issueTypeId];
	const transition = issueTypeTransitions?.find(
		(t) => t.destinationStatusId.toString() === statusId && !t.isInitial,
	);
	return transition?.id?.toString();
};
